import React from 'react'

class DashboardPeriodDetail extends React.Component {
  renderPeriodName () {
    const displayPeriodName = this.props.period !== moment(this.props.period_last_date).format('MMMM')
    if (displayPeriodName) {
      return (
        <div className='period-name'>
          {this.props.period}
        </div>
      )
    }
  }

  renderCalendarLink () {
    if (!this.props.isAdmin) {
      return (
        <a className='view-calendar-link' href={`/schedules?input_date_for_calendar_view=${this.props.period_last_date}`}>
          view calendar
        </a>
      )
    }
  }

  render () {
    return (
      <div className='dashboard-period-detail' onMouseLeave={this.props.mouseLeave} >
        { this.renderPeriodName() }
        <div className='period-month'>
          { moment(this.props.period_last_date).format('MMMM') }
        </div>
        { this.renderCalendarLink() }
      </div>
    )
  }
  
}

export default DashboardPeriodDetail
